import {
  Component,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { VtmnPlayButtonVariantEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-variant.enum';
import { VtmnPlayButtonSizeEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-size.enum';
import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';
import { VtmnPlayButtonShapeEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-shape.enum';
import { CustomHeadTagService } from '~/core/services/custom-head-tag/custom-head-tag.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-list-pagination',
  templateUrl: './list-pagination.component.html',
})
export class ListPaginationComponent implements OnInit, OnDestroy {
  @Input() public pagination?: number;
  @Input() public targetUrl?: string;

  public readonly vtmnPlayButtonSize = VtmnPlayButtonSizeEnum;
  public readonly vtmnPlayButtonVariant = VtmnPlayButtonVariantEnum;
  public readonly vtmnPlayIconTypeEnum = VtmnPlayIconTypeEnum;
  public readonly vtmnPlayButtonShape = VtmnPlayButtonShapeEnum;
  public pageArray = Array;
  public page: number;

  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: string,
    private readonly activatedRoute: ActivatedRoute,
    private readonly localizeRouterService: LocalizeRouterService,
    private readonly customHeadTagService: CustomHeadTagService
  ) {}

  public ngOnDestroy(): void {
    this.customHeadTagService.removeTag('prev');
    this.customHeadTagService.removeTag('next');
  }

  public ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (this.pagination > 1) {
        if (!this.isFirstPage) {
          this.paginatedContent('prev');
        }
        if (!this.isLastPage) {
          this.paginatedContent('next');
        }
      }
    }
  }

  private paginatedContent(property: string) {
    this.customHeadTagService.removeTag(property);

    const page =
      property === 'next' ? this.currentPage + 1 : this.currentPage - 1;

    this.customHeadTagService.addTag('link', {
      id: property,
      rel: property,
      href: `${window.location.origin}${window.location.pathname}?page=${page}`,
    });
  }

  public get currentPage(): number {
    return parseInt(this.activatedRoute?.snapshot?.queryParams?.page);
  }

  public get isFirstPage(): boolean {
    return this.currentPage === 1;
  }

  public get isLastPage(): boolean {
    return this.currentPage === this.pagination;
  }

  public get prevPageUrl(): string {
    return this.paginationUrlGenerator(this.currentPage, true);
  }

  public get nextPageUrl(): string {
    return this.paginationUrlGenerator(this.currentPage);
  }

  public paginationUrlGenerator(page: number, prev?: boolean) {
    if (isPlatformBrowser(this.platformId)) {
      const pager = prev ? page - 1 : page + 1;

      const baseSearch = window?.location?.search;
      const searchParams = new URLSearchParams(baseSearch);
      searchParams.set('page', pager.toString());

      return (
        this.localizeRouterService.translateRoute(`${this.targetUrl}`) +
        '?' +
        searchParams.toString()
      );
    }
  }

  public linkVariant(page: number): VtmnPlayButtonVariantEnum {
    return page === this.currentPage || (!this.currentPage && page === 1)
      ? this.vtmnPlayButtonVariant.SECONDARY
      : this.vtmnPlayButtonVariant.TERTIARY;
  }
}
